module.exports = __webpack_public_path__ + "static/media/aWaiver_Logo_w_Text.ee249fc8.svg";